import React from 'react';

const BS_CSS_Navs = () => {
    return (
        <div>
            <h1>BS_CSS_Navs Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_CSS_Navs;
